<template>
  <div>batch vvv</div>
</template>

<script>
export default {
  name: 'batch-history',
}
</script>

<style scoped></style>
